<template>
  <div class="doc-header container-fluid container-fluid--desktop bg-white sticky-top">
    <div class="row py-3 px-4 px-lg-5 align-items-center flex-nowrap justify-content-between">
      <div class="col-4 d-flex flex-md-grow-1 order-0 order-md-1 pl-0">
        <a
          aria-label="Informazioni Sula Pronuncia"
          class="document-ingo-link btn p-2 btn-outline-primary"
          href="#"
          data-toggle="modal"
          data-target="#modal-document-info"
          role="button">
          <span class="info-icon icon-primary" aria-hidden="true">
            <svg class="icon"><use :xlink:href="icons.itInfoCircle"></use></svg>
          </span>
          <span class="d-none d-md-inline align-middle">Informazioni Sulla Pronuncia</span>
        </a>
      </div>
      <div class="col-4 col-sm-auto d-flex flex-md-grow-1 align-items-center justify-content-center order-1">
        <div id="rst-menu" class="px-2">
          <div class="dropdown" id="version-list">
              <button
                class="btn btn-outline-primary dropdown-toggle text-nowrap"
                type="button"
                id="dropdownVersionButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <span class="current-version">Versioni</span>
                <span class="info-icon icon-primary" aria-hidden="true">
                  <svg class="icon"><use :xlink:href="icons.itArrowDownTriangle"></use></svg>
                </span>
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownVersionButton">
                <div class="version-list-wrapper">
                  <a class="dropdown-item" :href="`#${this.$router.currentRoute.path}`" disabled>Versione Unica</a>
                </div>
              </div>
          </div>
        </div>
      </div>
      <div class="col-4 d-none d-md-flex flex-grow-1 align-items-center order-1">
        <div class="document-actions d-flex flex-column flex-md-row justify-content-around w-100 p-2 p-md-0 text-blue">
          <div class="p-3 px-md-2 py-md-0">
            <a
              :href="getDownloadUrl(docUri)"
              role="button"
              class="btn p-2 btn-outline-primary"
              target="_blank"
              >
              <span class="info-icon icon-primary" aria-hidden="true">
                <svg class="icon"><use :xlink:href="icons.itCodeCircle"></use></svg>
              </span>
              <span class="d-none d-md-inline align-middle">Download Akoma Ntoso</span>
            </a>
          </div>
        </div>
      </div>
      <div class="col-3 pr-0 d-md-none d-flex align-items-center justify-content-end order-1">
        <a :href="getDownloadUrl(docUri)"
              role="button"
              class="btn p-2 btn-outline-primary"
              target="_blank">
          <span class="info-icon icon-primary" aria-hidden="true">
            <svg class="icon"><use :xlink:href="icons.itCodeCircle"></use></svg>
          </span>
          <span class="d-none d-md-inline align-middle">Download Akoma Ntoso</span>
        </a>
      </div>
    </div>
    <VueScrollProgressBar
      :containerClass="scrollContainerClass"
      :barClass="scrollBarClass"
      height="4px"
      backgroundColor="undefined" />
  </div>
</template>


<script>
import Vue from 'vue';
import VueScrollProgressBar from '@guillaumebriday/vue-scroll-progress-bar';
import sprites from 'bootstrap-italia/dist/svg/sprite.svg';

export default {
  name: 'HeaderDocument',
  props: ['docUri', 'year', 'number'],
  methods: {
    getDownloadUrl(docUri) {
      const separator = (process.env.NODE_ENV === 'development') ? '?' : '&';
      return `${Vue.prototype.$proxy}getDocument.xq${separator}uri=${docUri}&year=${this.year}&number=${this.number}`;
    },
  },
  data() {
    return {
      icons: {
        itArrowDownTriangle: `${sprites}#it-arrow-down-triangle`,
        itCodeCircle: `${sprites}#it-code-circle`,
        itSearch: `${sprites}#it-search`,
        itInfoCircle: `${sprites}#it-info-circle`,
        itMoreItems: `${sprites}#it-more-items`,
      },
      scrollContainerClass: {
        'progress-bar-container--container': false,
        'scrool-progress-bar': true,
      },
      scrollBarClass: {
        'primary-bg': true,
      },

    };
  },
  components: {
    VueScrollProgressBar,
  },
};
</script>

<style lang="less" scoped>
  .scrool-progress-bar {
    background-color:#e6f3fe!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/header/HeaderDocument.vue